"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SkillHistoryWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _badge = require("@design/ui/badge");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var SECTION_LABEL_CLASS = "mb-0.5 text-label-sm text-foreground-muted";
var SECTION_VALUE_CLASS = "whitespace-pre-wrap break-words text-caption text-foreground-muted";
var SkillHistoryWidgetComponent = function SkillHistoryWidgetComponent(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "my-1.5 max-h-75 max-w-full overflow-y-auto rounded-md border border-border-subtle bg-background-subtle p-3 opacity-85",
    "data-sentry-component": "SkillHistoryWidgetComponent",
    "data-sentry-source-file": "SkillHistoryWidget.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "mb-2 flex items-center gap-1.5",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.SparklesIcon, {
        className: "text-foreground-muted",
        "data-sentry-element": "SparklesIcon",
        "data-sentry-source-file": "SkillHistoryWidget.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-label-sm text-foreground-muted",
        children: "Skill suggestion"
      }), data.dismissed && /*#__PURE__*/(0, _jsxRuntime.jsx)(_badge.Badge, {
        variant: "secondary",
        className: "ml-auto",
        children: "Dismissed"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "mb-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: SECTION_LABEL_CLASS,
        children: "Name"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: SECTION_VALUE_CLASS,
        children: data.name
      })]
    }), data.description && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "mb-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: SECTION_LABEL_CLASS,
        children: "Description"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: SECTION_VALUE_CLASS,
        children: data.description
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "mb-2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: SECTION_LABEL_CLASS,
        children: "Skill Prompt"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: SECTION_VALUE_CLASS,
        children: data.content
      })]
    })]
  });
};
var SkillHistoryWidget = exports.SkillHistoryWidget = /*#__PURE__*/_react.default.memo(SkillHistoryWidgetComponent);
var _default = exports.default = SkillHistoryWidget;